import React, { ReactNode } from 'react';
import { Typography } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

type SummaryLabelledInfoProps = {
  children: ReactNode;
  isTable?: boolean;
  label: string;
};

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(2),
  },
  label: {
    fontWeight: 500,
  },
}));

export const SummaryLabelledInfo = ({
  children,
  label,
  isTable,
}: SummaryLabelledInfoProps) => {
  const classes = useStyles();

  return (
    <>
      {children ? (
        <div className={classes.container}>
          <Typography className={classes.label} gutterBottom variant="caption">
            {label}
          </Typography>
          {isTable ? children : <Typography>{children}</Typography>}
        </div>
      ) : null}
    </>
  );
};
